module.exports = __webpack_public_path__ + "img/granada3.d29532bc.jpg";